const SectionHome = Class(
	/**
	 * @lends {SectionHome#}
	 */
	{
		__NAME: 'SectionHome',

		background: null,
		bodyClass: 'small-nav',

		__construct: function () {
			this.node = mkE({
				tag: 'div',
				id: 'SectionHome'
			});
		},


		draw() {
			this.node.append(this.layout.ct());
			this._draw();
			this.ready();
		},

		_draw() {
			let apiCall = new DR.ApiCall();

			mkE({
				tag: 'div',
				id: 'hero-home',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'div',
								className: 'hero-home-lottie'
							},
							{
								tag: 'div',
								className: 'hero-home-content',
								els: [
									{
										tag: 'h1',
										innerHTML: D.Lang.get('home.welcome.title')
									},
									{
										tag: 'p',
										className: 'text',
										text: D.Lang.get('home.welcome.text')
									},
									{
										tag: 'div',
										className: 'hero-home-button-container',
										els: [
											{
												tag: 'a',
												href: D.url(D.Lang.get('home.welcome.button.link')),
												className: 'button button-large button-pink',
												text: D.Lang.get('home.welcome.button')
											}
										]
									},
									{
										tag: 'div',
										className: 'sub-text',
										els: [
											{
												tag: 'div',
												className: 'qr-text',
												text: D.Lang.get('home.welcome.qr.text')
											},
											{
												tag: 'div',
												className: 'sub-text-info',
												els: [
													{
														tag: 'div',
														className: 'qr-image',
														els: [
															{
																tag: 'a',
																href: D.url('/get-app'),
																els: [
																	{
																		tag: 'img',
																		width: 120,
																		height: 120,
																		src: '/assets/images/qr.svg?v=2'
																	}
																]
															}
														]
													},
													{
														tag: 'div',
														className: 'info',
														els: [
															{
																tag: 'div',
																className: 'counters',
																els: [
																	{
																		tag: 'div',
																		className: 'counter',
																		els: [
																			this._countAdventurersNode = mkE({
																				tag: 'div',
																				className: 'count',
																				text: 46007
																			}),
																			{
																				tag: 'div',
																				text: D.Lang.get('home.welcome.counter.adventures')
																			}
																		]
																	},
																	{
																		tag: 'div',
																		className: 'counter',
																		els: [
																			this._countGamesNode = mkE({
																				tag: 'div',
																				className: 'count',
																				text: 52282
																			}),
																			{
																				tag: 'div',
																				text: D.Lang.get('home.welcome.counter.games')
																			}
																		]
																	},
																	D.ADMIN_STATS && D.ADMIN_STATS['b2b'] ? {
																		tag: 'div',
																		className: 'counter',
																		els: [
																			{
																				tag: 'div',
																				className: 'count',
																				els: [
																					{
																						tag: 'a',
																						href: '/monitor/b2b/',
																						className: 'noAjax',
																						style: {
																							color: '#000'
																						},
																						els: [
																							{
																								tag: 'span',
																								text: D.ADMIN_STATS['b2b']
																							},
																							' / ',
																							{
																								tag: 'span',
																								style: {
																									color: '#ff4370'
																								},
																								text: D.ADMIN_STATS['b2b_target']
																							}
																						]
																					}
																				]
																			},
																			{
																				tag: 'div',
																				text: 'Jauni B2B spēlētāji'
																			}
																		]
																	} : ''
																]
															},
															{
																tag: 'div',
																className: 'underline',
																els: D.Lang.get('home.welcome.counter.underline')
															}
														]
													}
												]
											}
										]
									}
								]
							}
						]
					},
					new SectionHome.EventTypes()
				]
			}).append(this.node);

			this._mStats = new DR.web.Stats();
			this._mStats.onLoad = this._mStatsRe;
			apiCall.addMethod(this._mStats);

			mkE({
				tag: 'div',
				className: 'events-featured container',
				els: [
					this._featuredEvent = new T.FeaturedEvent('events', null)
				]
			}).append(this.node);

			mkE({
				tag: 'div',
				className: 'game-flow-wrapper',
				els: [
					new T.GameFlow()
				]
			}).append(this.node);

			this._drawGames(apiCall);

			new T.InstagramFeed(apiCall).append(this.node);

			this._testimonials = T.Quotes.get('event');
			if( this._testimonials ) {
				mkE({
					tag: 'div',
					className: 'testimonials-wrapper',
					els: [
						this._testimonials
					]
				}).append(this.node);
			}

			if( D.LANG === 'en' ) {
				mkE({
					tag: 'div',
					className: 'corporate-form-wrapper',
					els: [
						new T.CorporateContactUs({
							fromHome: true
						})
					]
				}).append(this.node);
			} else {
				new T.FooterRegister().append(this.node);
			}

			apiCall.call();
		},

		/**
		 * @param {DR.ApiCall} apiCall
		 * @private
		 */
		_drawGames: function ( apiCall ) {
			let els = [];
			for( let i = 0; i < 4; i++ ) {
				els.push(new T.ListEvent());
			}
			this._eventsListNode = mkE({
				tag: 'div',
				className: 'events-list with-footer container',
				els: [
					{
						tag: 'h3',
						text: D.Lang.get('home.games.listTitle')
					},
					this._sliderContainer = mkE({
						tag: 'div',
						els: [
							this._slider = new T.Glider(new T.Glider.Par().setContent(els))
						]
					}),
					{
						tag: 'div',
						className: 'events-list-footer',
						els: [
							{
								tag: 'a',
								href: D.url('/events'),
								className: 'button button-pink button-large',
								text: D.Lang.get('home.games.showAll')
							}
						]
					}
				]
			}).append(this.node);

			this._mGetEvents = new DR.web.GetEvents();
			this._mGetEvents.pg = 1;
			this._mGetEvents.count = 20;
			this._mGetEvents.type = DR.web.GetEvents.TYPE_HOME;
			this._mGetEvents.onLoad = this._mGetEventsRe;
			this._mGetEvents.select = [
				new DR.events.select.Event().id().title().description().startTime().endTime().registrationDate().ticket().image().status()
					.maxPlayers().seoTitle().hasTeam().hasImage().settings().hasLandingPage().stats().userRating().isNewGame(),
				new DR.roadgames.select.Image().original().large().medium()
			];
			apiCall.addMethod(this._mGetEvents);
		},

		_mGetEventsRe() {
			if( this._mGetEvents.re.featuredEvent ) {
				this._featuredEvent.setEvent(this._mGetEvents.re.featuredEvent);
			} else {
				this._featuredEvent.node.parentNode.remove();
			}
			if( this._mGetEvents.re.events.length ) {
				let els = [];
				for( let i = 0; i < this._mGetEvents.re.events.length; i++ ) {
					const event = this._mGetEvents.re.events[i];
					if( !event.hasLandingPage ) {
						continue;
					}
					els.push(new T.ListEvent(event));
				}
				this._slider.onLeave();
				this._slider.remove();
				this._slider = new T.Glider(new T.Glider.Par().setContent(els)).append(this._sliderContainer);
				if( this.isReady ) {
					this._slider.onShow();
				}
			} else {
				this._slider.onLeave();
				this._eventsListNode.remove();
			}
		},

		_mStatsRe() {
			setNodeText(this._countAdventurersNode, this._mStats.re.adventurers);
			setNodeText(this._countGamesNode, this._mStats.re.games);
		},

		onShow() {
			if( this._testimonials ) {
				this._testimonials.onShow();
			}
			if( this._gameSetup ) {
				this._gameSetup.onShow();
			}
			if( this._slider ) {
				this._slider.onShow();
			}
			if( this._gallerySlider ) {
				this._gallerySlider.onShow();
			}
		},

		onLeave() {
			if( this._testimonials ) {
				this._testimonials.onLeave();
			}
			if( this._gameSetup ) {
				this._gameSetup.onLeave();
			}
			if( this._slider ) {
				this._slider.onLeave();
			}
			if( this._gallerySlider ) {
				this._gallerySlider.onLeave();
			}
		}
	},
	Section
);